/**
 * Skip link for keyboard navigation accessibility
 * Allows users to skip directly to main content
 */
export function SkipLink() {
  return (
    <a href="#main-content" className="skip-link">
      Skip to main content
    </a>
  );
}
